module.exports = __webpack_public_path__ + "img/head_bg2.2fb5c111.jpg";